<template>
    <div class="publish-comment" :style="focusStatus? 'border: 1px solid #46B4B1;': ''">
        <textarea class="publish-comment__textarea" :placeholder="placeholder" v-model="comment" @focus="focus" @blur="blur" :style="focusStatus? 'min-height: 100px;': ''"></textarea>
        <div class="publish-comment__btn-area">
            <!-- <img class="publish-comment__add-picture" src="@/assets/images/add-picture.svg" alt=""> -->
            <span class="publish-comment__count">{{comment.replace(' ','').trim().length}} / {{ inputCount }}</span>
            <el-button class="publish-comment__btn" :disabled="!comment.trim()"  @mousedown.native.stop="handleMouseDown" @click="publishComment" style="background-color: #46B4B1; border-color: #46B4B1;">发送</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: 'publish-comment',
    props: {
        placeholder: {
            type: String,
            default: '',
        },
        inputCount: {
            type: Number,
            default: 1000,
        },
    },
    data() {
        return {
            comment: '',
            focusStatus: false
        }
    },
    methods: {
        focus() {
            this.focusStatus = true
        },
        blur() {
            this.focusStatus = false
        },
        handleMouseDown(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
        },
        publishComment() {
            this.$emit('publishComment', this.comment);
            this.comment = '';
        },

    },
    mounted() {

    }
}
</script>
<style lang="scss" scoped>
.publish-comment {
        padding: 8px 12px;
        background-color: #F2F3F5;
        resize: none;
        box-sizing: border-box;
        border-radius: 5px;
        font-size: 16px;
        color: #515767;
    .publish-comment__textarea {
        min-height: 56px;
        transition: min-height 0.3s ease;
        background: none;
        width: 100%;
    }

    .publish-comment__btn-area {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .publish-comment__add-picture {
        width: 20px;
        margin-right: 16px;
    }

    .publish-comment__count {
        margin-right: 16px;
        font-size: 14px;
        color: #515767;
    }

    .publish-comment__btn {
        padding: 0px 12px;
        border-radius: 5px;
        line-height: 32px;
        color: #FFF;
        &:hover {
            background-color: #378F8C !important;
            border-color: #378F8C !important;
        }

        &:focus {
            background-color: #46B4B1 !important;
            border-color: #46B4B1 !important;
        }
    }
}</style>